/* css for nav background color on blog page */
#main-content > .container:before {
  content: ' ';
  display: block;
  position: absolute;
  max-width: inherit;
  width: 100%;
  top: 0;
  height: 20%;
  background: $color-white;
}

snt-title {
  .header {
    text-align: center;
  }

  @include applyThemeMap($themes);

  .spacings {
    @include layout();
  }
  
  &.left .header,
  .left & .header {
    text-align: left;
  }
  &.right .header,
  .right & .header {
    text-align: right;
  }
  &.center .header,
  .center & .header {
    text-align: center;
  }

  @media (max-width: map-get($container-max-widths, sm)) {
    &.left-mobile .header,
    .left-mobile & .header {
      text-align: left;
    }

    &.right-mobile .header,
    .right-mobile & .header {
      text-align: right;
    }

    &.center-mobile .header,
    .center-mobile & .header {
      text-align: center;
    }
  }
}
